import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles<Theme>(theme => ({
    button: {
        backgroundColor: `${theme.palette.success.main} !important`,
        '& :focus': {
            outline: 'none',
        },
        '&:hover': {
            transform: 'scale(1.05)',
            transition: 'all 0.2s ease-in-out',
        },
        [theme.breakpoints.down('md')]: {
            height: '70px',
            fontSize: '22px',
            borderRadius: '5px',
            position: 'sticky',
            left: 0,
            bottom: 0,
        },
        borderRadius: '50px',
        width: '100%',
        fontSize: '18px',
        height: '55px',
        border: 0,
        color: 'white',
    },
}));
